import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseListService } from '../../../../@core/services/base-list.service';
import { SystemService } from '../../../../@core/services/system.service';
import { DELETE_COST_BASE, GET_COST_BASE, GET_COST_BASES, SAVE_COST_BASE } from '../../../../data/definitions/cost-types.definition';
import { BaseDataService } from '../../../../data/services/base-data.service';
import { DataService } from '../../../../data/services/data.service';
import { CostBase, CostBaseInput, DeleteCostBaseMutation, DeleteCostBaseMutationVariables, DeletionResponse, GetCostBaseQuery, GetCostBaseQueryVariables, GetCostBasesQuery, GetCostBasesQueryVariables, SaveCostBaseMutation, SaveCostBaseMutationVariables, SearchInput } from '../../../../generated/generated-types';

@Injectable({
  providedIn: 'root'
})
export class CostBaseService extends BaseListService<CostBase> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }

  getItems(searchInput?: SearchInput) {

    let fragment = GET_COST_BASES;

    return this.baseDataService.query<GetCostBasesQuery, GetCostBasesQueryVariables>(
      fragment, {
      input: searchInput as any
    });
  }

  getItem(id: string) {
    return this.baseDataService.query<GetCostBaseQuery, GetCostBaseQueryVariables>(
      GET_COST_BASE, {
      id: id
    });
  }

  async getItemData(id: string): Promise<CostBase> {
    let comp = await lastValueFrom(this.getItem(id).mapSingle(x => x.getCostBase));
    return comp as CostBase;
  }

  async saveItem(item: CostBase | CostBaseInput) {

    let validated = await this.systemService.validateObject<CostBaseInput>(item, "CostBaseInput");

    let saved = await lastValueFrom(this.baseDataService.mutate<SaveCostBaseMutation, SaveCostBaseMutationVariables>(
      SAVE_COST_BASE, {
      input: validated
    }));
    return saved.saveCostBase as CostBase;
  }

  async deleteItem(id: string): Promise<DeletionResponse> {

    let res = await lastValueFrom(this.baseDataService.mutate<DeleteCostBaseMutation, DeleteCostBaseMutationVariables>(
      DELETE_COST_BASE, {
      id: id
    }));

    return res.deleteCostBase
  }

  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getCostBase);
  }
}
